import {createFileRoute} from '@tanstack/react-router';
import {PaymentCallbackCancelPage} from 'features/shared/payment/pages/PaymentCallbackCancelPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/callback/_statuses/cancel',
)({
  component: () => (
    <PaymentCallbackCancelPage
      pageId="bill_payment_cancelled"
      navigateTo="/home/statements"
    />
  ),
});
